import { COUNTRY_DEFAULT_LOCALE } from "../../presentation/utils/countryDefaultLocale";
const resolveLocale = () => {
    var _a, _b;
    const country = ((_a = sessionStorage.getItem("country")) !== null && _a !== void 0 ? _a : "").toUpperCase();
    return (_b = COUNTRY_DEFAULT_LOCALE[country]) !== null && _b !== void 0 ? _b : "en-US";
};
export class UseCaseConvertPrice {
    handle(price, rate, currency, taxes, totalDays) {
        let totalPrice = "";
        let dailyPrice = "";
        let priceWithTaxes = price;
        let priceConverted = priceWithTaxes / rate;
        const locale = resolveLocale();
        totalPrice = Math.round(priceConverted).toLocaleString(locale);
        if (totalDays <= 1) {
            dailyPrice = Math.round((priceConverted - (priceConverted * taxes)) / 1).toLocaleString(locale);
        }
        else {
            dailyPrice = Math.round((priceConverted - (priceConverted * taxes)) / totalDays).toLocaleString(locale);
        }
        return {
            totalPrice: totalPrice,
            dailyPrice: dailyPrice
        };
    }
}
